// 3A Finans - Format yardımcıları

// 1.234.567 ₺ formatı (binlik nokta)
export const formatTL = (value, decimals = 0) => {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const formatted = Number(value).toLocaleString("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${formatted} ₺`;
};

// GG.AA.YYYY formatı
export const formatDate = (isoDate) => {
  if (!isoDate) return "—";
  try {
    const d = new Date(isoDate);
    if (isNaN(d.getTime())) return isoDate;
    const gg = String(d.getDate()).padStart(2, "0");
    const aa = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${gg}.${aa}.${yyyy}`;
  } catch {
    return isoDate;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const saat = String(d.getHours()).padStart(2, "0");
    const dk = String(d.getMinutes()).padStart(2, "0");
    return `${formatDate(iso)} ${saat}:${dk}`;
  } catch {
    return iso;
  }
};

export const ROL_ETIKETLERI = {
  yonetici: "Yönetici",
  operasyon: "Operasyon",
  goruntuleyici: "Görüntüleyici",
};
